

export default class Licencia {
    /**
     *
     * @param {callback} opt.then
     * @param {callback} opt.headers
     * @param {callback} opt.always
     * @param {callback} opt.fail
     */
    static activar(id, opt) {
        Ajax.put('/api/admin/licencias/' + id + '/activar', {}, opt);
    }

    /**
     *
     * @param {callback} opt.then
     * @param {callback} opt.headers
     * @param {callback} opt.always
     * @param {callback} opt.fail
     */
    static desactivar(id, opt) {
        Ajax.put('/api/admin/licencias/' + id + '/desactivar', {}, opt);
    }

    /**
     *
     * @param {number} id
     * @param {callback} opt.then
     * @param {callback} opt.headers
     * @param {callback} opt.always
     * @param {callback} opt.fail
     */
    static enviarCorreo(id, opt) {
        Ajax.post('/api/admin/licencias/' + id + '/enviar-correo', {}, opt);
    }

    /**
     *
     * @param {number} id
     * @param {callback} opt.then
     * @param {callback} opt.headers
     * @param {callback} opt.always
     * @param {callback} opt.fail
     */
    static enlazarNotificacion(notificacionId, opt) {
        Ajax.put('/api/admin/licencias/enlazar-a-notificacion', {notificacionId: notificacionId}, opt);
    }
}
